import React, { CSSProperties } from "react";
import "./slide.scss";

export interface SlideProps {
	content: string;
	style?: CSSProperties;
	className?: string;
}

const Slide = (props: SlideProps) => {
	const createMarkup = () => {
		const md = require("markdown-it")({
			html: true,
		});
		return {
			__html: md.render(props.content),
		};
	};

	return (
		<div
			className={`slide ${props.className}`}
			style={props.style}
			dangerouslySetInnerHTML={createMarkup()}
		/>
	);
};

export { Slide };
